<template>
  <VDialog
    @click:outside="$emit('close')"
    @keydown.esc="$emit('close')"
    @keydown.enter="destroyQuestion"
    :value="value"
    max-width="450"
  >
    <VCard class="text-center pa-3">
      <div class="title mb-3">
        {{ $t('deleteWarning') }}
      </div>
      <VBtn
        color="success"
        ref="focusButton"
        text
        @click="destroyQuestion"
      >
        {{ $t('yes') }}
      </VBtn>

      <VBtn
        color="grey darken-1"
        text
        @click="closeDestroyDialog"
      >
        {{ $t('no') }}
      </VBtn>
    </VCard>
  </VDialog>
</template>
<script>
export default {
  name: 'VacancyQuestionDestroyDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },

    },
  },
  watch: {
    value(val) {
      if (val) {
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.$refs.focusButton) {
              this.$refs.focusButton.$el.focus();
            }
          }, 100);
        });
      }
    },
  },
  methods: {
    closeDestroyDialog() {
      this.show = false;
    },
    destroyQuestion() {
      this.$emit('destroy');
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
  deleteWarning: Are you sure you want to delete this question?
  yes: Yes
  no: No
</i18n>

<i18n locale="ru" lang="yaml">
  deleteWarning: Вы уверены, что хотите удалить вопрос?
  yes: Да
  no: Нет
</i18n>
